import React from 'react'

import { Invoice } from '../../../types'
import InvoiceStackedCard from './InvoiceStackedCard'

import './styles.scss'

type Props = {
  invoices: Invoice[]
  activeInvoiceId?: string
  emptyMessage?: string
}

const InvoiceStackedList: React.FC<Props> = ({
  invoices,
  activeInvoiceId,
  emptyMessage = 'No invoices yet',
}) => {
  if (invoices.length === 0) {
    return <div className='invoice-stacked-list__empty'>{emptyMessage}</div>
  }

  return (
    <div className='invoice-stacked-list'>
      {invoices.map((invoice) => (
        <InvoiceStackedCard
          key={invoice._id}
          invoice={invoice}
          isActive={!!activeInvoiceId && invoice._id === activeInvoiceId}
        />
      ))}
    </div>
  )
}

export default InvoiceStackedList
